<template>
  <div
    id="EfectosPosibles"
    v-if="
      $store.state.global_privilegio_admin_registro_efecto_posible.ver"
  >
    <AdminMenu />
    <div class="row justify-content-md-center align-items-center">
      <div class="col-md-10">
        <div class="row container_admin">
          <!-- LISTA DE EFECTOS POSIBLES -->
          <div class="col-6 text-left mt-2">
            <b class="titulo">Efectos Posibles</b>
          </div>
          <div class="col-6 d-flex justify-content-end mt-3">
            <button
              v-show="
                $store.state.global_privilegio_admin_registro_efecto_posible
                  .crear
              "
              type="button"
              class="btn boton_guardar1"
              data-toggle="modal"
              data-target="#agregarefecto"
              style="margin-right: 2%; width: 280px !important"
            >
              <img
                src="img/iconos/efecto_posible.png"
                alt="logo-color"
                class="icono"
              />Nuevo Efecto Posible
            </button>
          </div>
          <div class="col-12 table mt-3">
            <div
              v-if="
                this.$store.state.global_privilegio_admin_registro_efecto_posible
                  .ver == true && informacion_efecto.length > 0
              "
            >
              <v-client-table
                class="col-md-12 mt-3"
                :columns="columns"
                :data="informacion_efecto"
                :options="options"
              >
                <div slot="opciones" slot-scope="props">
                    <button
                      class="btn dropdown-toggle boton_12"
                      data-toggle="dropdown"
                      aria-expanded="false"
                    >
                      <ul class="dropdown-menu b-dropdown-opt" role="menu">
                          <li>
                            <a
                              class="btn btn-block mi_boton"
                              @click="
                                consultar_efecto_posible(
                                  props.row.id,
                                  props.row.id_peligro,
                                  props.row.id_subcla
                                )
                              "
                              v-show="
                                $store.state
                                  .global_privilegio_admin_registro_efecto_posible
                                  .editar
                              "
                              >&nbsp;<b>Editar</b></a
                            >
                          </li>
                          <li>
                            <a
                              class="btn btn-block mi_boton"
                              @click="eliminar_descripcion(props.row.id)"
                              v-show="
                                $store.state
                                  .global_privilegio_admin_registro_efecto_posible
                                  .eliminar
                              "
                              >&nbsp;<b>Eliminar</b></a
                            >
                          </li>
                      </ul>
                    </button>
                </div>
              </v-client-table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- MODAL AGREGAR EFECTOS POSIBLES -->
    <div
      class="modal fade"
      id="agregarefecto"
      data-backdrop="static"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-xl">
        <div class="modal-content container_admin">
          <div class="modal-body">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <div class="col-md-10">
              <label class="dato ml-3"><b>Efectos Posibles</b></label> <br />
            </div>
            <div class="box-body row">
              <div class="col-md-3">
                <label class="color_letra mt-3">Elegir el Peligro:</label>
                <select
                  class="form-control boton_texto"
                  v-model="id_peligro"
                  @change="consulta_subclasificaciones()"
                >
                  <option value="">Peligros</option>
                  <option
                    v-for="(item8, index) of mostrar_peligros"
                    :value="item8.key"
                    :key="index"
                  >
                    {{ item8.c_nuevo_peligros }}
                  </option>
                </select>
              </div>
              <div class="col-md-3">
                <label class="color_letra mt-3"
                  >Elegir la Subclasificación:</label
                >
                <select
                  class="form-control boton_texto"
                  v-model="id_subcla"
                  required
                >
                  <option value="">Subclasificación</option>
                  <option
                    v-for="(item9, index) of mostrar_subcla"
                    :value="item9.key_sublca"
                    :key="index"
                  >
                    {{ item9.c_nuevo_sub }}
                  </option></select
                ><br />
              </div>
              <div class="col-md-3 mt-3">
                <label class="color_letra"
                  >Nombre Nuevo Efecto:
                  <span class="badge text-secondary"
                    ><i
                      class="fas fa-question-circle fa-lg"
                      data-toggle="tooltip"
                      data-placement="right"
                      data-html="true"
                      title="Ingrese el nuevo efecto posible acorde a la subclasificación del peligro seleccionado."
                    ></i></span
                ></label>
                <input
                  type="text"
                  v-model.trim="texto_siguiente"
                  class="form-control boton_texto"
                  placeholder="Efecto Posible"
                  required
                />
              </div>
              <div class="col-md-3 mt-5">
                <button class="btn boton_12" @click="add_texto()">
                  Agregar Efecto
                </button>
              </div>
              <div class="col-md-12">
                <span
                  v-for="(texto, index) in array_textos"
                  :key="index"
                  style="
                    background-color: gray;
                    border-radius: 5px;
                    font-size: 14px;
                    color: white;
                    font-weight: bold;
                    font-family: Arial, Helvetica, sans-serif;
                    padding: 5px;
                    margin: 5px;
                    line-height: 20pt;
                  "
                >
                  <span
                    type="button"
                    @click="eliminar_texto(texto)"
                    class="badge badge-light mt-3"
                    >X</span
                  >
                  &nbsp;{{ texto }}
                </span>
              </div>
              <div class="col-md-6">
                <label class="color_letra mt-3"
                  >* Agregar el efecto antes de guardar.</label
                >
              </div>
              <div class="col-md-12">
                <center>
                  <button
                    type="button"
                    class="btn boton_guardar1"
                    style="width: 220px !important"
                    @click="
                      agregar_efecto_posible(
                        id_peligro,
                        id_subcla,
                        array_textos
                      )
                    "
                  >
                    Guardar
                  </button>
                </center>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- MODAL EDITAR EFECTOS POSIBLES -->
    <div
      class="modal fade"
      id="editarefectos"
      data-backdrop="static"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-xl">
        <div class="modal-content container_admin">
          <div class="modal-body">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <div class="col-md-10">
              <label class="dato ml-3"><b>Editar Efectos Posibles</b></label>
              <br />
            </div>
            <div class="box-body row">
              <div class="col-md-3">
                <label class="color_letra mt-3">Peligro:</label>
                <select
                  class="form-control boton_texto"
                  v-model="con_peligro"
                  @change="consulta_peligro()"
                  required
                >
                  <option value="">Peligros</option>
                  <option
                    v-for="(item5, index) of mostrar_peligros"
                    :value="item5.c_nuevo_peligros"
                    :key="index"
                  >
                    {{ item5.c_nuevo_peligros }}
                  </option>
                </select>
              </div>
              <div class="col-md-3">
                <label class="color_letra mt-3">Subclasificación:</label>
                <select
                  class="form-control boton_texto"
                  v-model="con_subcla"
                  required
                >
                  <option value="">Subclasificación</option>
                  <option
                    v-for="(item4, index) of mostrar_subcla_descripcion"
                    :value="item4.efecto_nuevo_sub"
                    :key="index"
                  >
                    {{ item4.efecto_nuevo_sub }}
                  </option></select
                ><br />
              </div>
              <div class="col-md-3 mt-5">
                <input
                  type="text"
                  v-model.trim.lazy="texto_siguiente_editar"
                  class="form-control boton_texto"
                  placeholder="Efecto Posible"
                  required
                />
              </div>
              <div class="col-md-3 mt-5">
                <button class="btn boton_12" @click="add_texto_editar()">
                  Agregar Efecto
                </button>
              </div>
              <div class="col-md-12 mt-3">
                <label class="color_letra">Efecto:</label><br />
                <span
                  v-for="(efecto, index) in con_efecto"
                  :key="index"
                  style="
                    background-color: gray;
                    border-radius: 5px;
                    font-size: 14px;
                    color: white;
                    font-weight: bold;
                    font-family: Arial, Helvetica, sans-serif;
                    padding: 5px;
                    margin: 5px;
                    line-height: 20pt;
                  "
                >
                  <span
                    type="button"
                    @click="eliminar_texto_editar(efecto)"
                    class="badge badge-light mt-3"
                    >X</span
                  >&nbsp;{{ efecto }}
                </span>
              </div>
              <div class="col-md-12">
                <center>
                  <br />
                  <button
                    type="button"
                    class="btn boton_guardar1 mr-3"
                    style="width: 200px !important"
                    @click="editar_id_peligro()"
                  >
                    Guardar
                  </button>
                  <button
                    type="button"
                    class="btn boton_cancelar"
                    @click="vaciar_variables()"
                  >
                    Cancelar
                  </button>
                </center>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- NO TIENE PERMISO PARA VER EL MÓDULO -->
  <div class="alert alert-warning" role="alert" v-else>
    No tiene permiso para ver el Módulo
  </div>
</template>

<script>
// IMPORTACIÓN DE FIREBASE
import { firebase, auth, db } from "../../firebase";
// IMPORTACIÓN DE SWEET ALERT
import Swal from "sweetalert2";
import AdminMenu from "@/components/AdminMenu.vue";
import NProgress from "nprogress";
import "nprogress/nprogress.css";

export default {
  name: "EfectosPosibles",
  components: {
    AdminMenu,
  },
  data() {
    return {
      subla_existe: "",
      // ARRAYS
      mostrar_peligros: [],
      mostrar_subcla: [],
      message: [],
      mostrar_subcla_descripcion: [],
      texto_siguiente: "",
      texto_siguiente_editar: null,
      array_textos: [],
      array_peligro: [],
      array_subcla: [],
      efecto: [],

      // VARIABLE PARA REGISTRO DE EFECTOS POSIBLES
      id_peligro: "",
      id_subcla: "",

      // VARIABLE CONSULTA
      c_key_efecto: "",
      c_efecto: [],
      con_efecto: [],
      con_subcla: "",
      con_key: "",
      con_peligro: "",
      con_registrado: "",

      // VARIABLES PARA LA TABLA DESCRIPCIÓN
      informacion_efecto: [],
      columns: ["peligro_nuevo", "subcla_nueva", "efecto_posible", "opciones"],
      options: {
        headings: {
          peligro_nuevo: "Peligro",
          subcla_nueva: "Subclasificación",
          efecto_posible: "Efectos Posibles",
          opciones: "Opciones",
        },
        sortable: ["peligro_nuevo", "subcla_nueva", "efecto_posible"],
        texts: {
          filter: "Buscar",
          filterPlaceholder: "",
        },
      },
    };
  },
  created() {
    if (
      this.$store.state.global_privilegio_admin_registro_efecto_posible.ver ==
      true
    ) {
      this.tabla_peligro();
    }
    let docRef = db
      .collection("nuevo_peligro")
      .orderBy("p_nuevo_peligro", "asc");
    docRef.onSnapshot((querySnapshot) => {
      // LIMPIAR ARRAY ANTES DE CONSULTAR
      this.mostrar_peligros = [];
      querySnapshot.forEach((doc) => {
        this.mostrar_peligros.push({
          key: doc.id,
          c_nuevo_peligros: doc.data().p_nuevo_peligro,
        });
      });
      console.log('datos', this.mostrar_peligros)
    });
    $(function () {
      $('[data-toggle="tooltip"]').tooltip();
    });
  },
  methods: {
    // CONSULTAR LAS SUBCLASIFICACIONES
    consulta_subclasificaciones() {
      NProgress.start();
      db.collection("nuevo_subclasificacion")
        .where("p_id_peligro", "==", this.id_peligro)
        .orderBy("p_nuevo_subclasificacion", "asc")
        .get()
        .then((querySnapshot) => {
          this.mostrar_subcla = [];
          querySnapshot.forEach((doc) => {
            this.mostrar_subcla.push({
              key_sublca: `${doc.id}`,
              c_nuevo_sub: `${doc.data().p_nuevo_subclasificacion}`,
            });
          });
        });
      NProgress.done();
      NProgress.remove();
    },

    // FUNCIÓN PARA MOSTRAR TABLA DESCRIPCIÓN
    async tabla_peligro() {
      NProgress.start();

      try {
        const peligroSnapshot = await db.collection("nuevo_peligro").get();
        const peligros = peligroSnapshot.docs.map(doc => ({
          id: doc.id,
          peligro: doc.data().p_nuevo_peligro
        }));

        for (const { id: idPeligro, peligro } of peligros) {
          await this.tabla_subcla(idPeligro, peligro);
        }
      } catch (error) {
        console.error("Error al obtener peligros:", error);
      }

      NProgress.done();
    },

    async tabla_subcla(idPeligro, peligro) {

      try {
        const subclaSnapshot = await db.collection("nuevo_subclasificacion").get();
        const subclasificaciones = subclaSnapshot.docs.map(doc => ({
          id: doc.id,
          subclasificacion: doc.data().p_nuevo_subclasificacion
        }));

        for (const { id: idSubcla, subclasificacion } of subclasificaciones) {
          await this.tabla_efecto_posible(idPeligro, peligro, idSubcla, subclasificacion);
        }
      } catch (error) {
        console.error("Error al obtener subclasificaciones:", error);
      }
    },

    async tabla_efecto_posible(idPeligro, peligro, idSubcla, subclasificacion) {

      try {
        const efectoSnapshot = await db.collection("nuevo_efecto_posible")
          .where("e_id_peligro", "==", idPeligro)
          .where("e_id_subcla", "==", idSubcla)
          .orderBy("e_fecha_registro", "desc")
          .get();

        efectoSnapshot.docs.forEach(doc => {
          const efectos = doc.data().e_efecto_posible; // Esto es un array
          efectos.forEach(efecto => {
            this.informacion_efecto.unshift({
              id: doc.id,
              peligro_nuevo: peligro,
              subcla_nueva: subclasificacion,
              efecto_posible: efecto,
              id_peligro: doc.data().e_id_peligro,
              id_subcla: doc.data().e_id_subcla,
            });
          });
        });

        // DEVOLVER SOLO DATOS ÚNICOS, NO REPETIDOS
        const uniqueEfectos = Array.from(new Set(this.informacion_efecto.map(a => JSON.stringify(a)))).map(a => JSON.parse(a));
        this.informacion_efecto = uniqueEfectos;

      } catch (error) {
        console.error("Error al obtener efectos posibles:", error);
      }

      NProgress.done();
      NProgress.remove();
    },

    add_texto() {
      if (!this.texto_siguiente.trim()) {
        Swal.fire({
          position: "center",
          icon: "error",
          title: "Recuerde que todos los campos son obligatorios.",
          showConfirmButton: false,
          timer: 2500,
          allowOutsideClick: false,
          allowEscapeKey: false,
        });
        return;
      }
      this.array_textos.push(this.texto_siguiente);
    },

    add_texto_editar() {
      if (!this.texto_siguiente_editar.trim()) {
        return;
      }
      this.con_efecto.push(this.texto_siguiente_editar);
      this.texto_siguiente_editar = null;
    },

    eliminar_texto(efecto) {
      alert("Se eliminará este efecto: " + efecto);
      for (let i = 0; i < this.array_textos.length; i++) {
        if (this.array_textos[i] === efecto) {
          this.array_textos.splice(i, 1);
        }
      }
    },

    eliminar_texto_editar(efecto) {
      alert("Se eliminará este efecto: " + efecto);
      for (let i = 0; i < this.con_efecto.length; i++) {
        if (this.con_efecto[i] === efecto) {
          this.con_efecto.splice(i, 1);
        }
      }
    },

    // FUNCIÓN PARA AGREGAR A LA BASE DE DATOS EFECTOS POSIBLES
    agregar_efecto_posible(id_peligro, id_subcla, efectos) {
      if (
        this.id_peligro == "" ||
        this.id_subcla == "" ||
        this.texto_siguiente == ""
      ) {
        Swal.fire({
          position: "center",
          icon: "error",
          title: "Recuerde que todos los campos son obligatorios.",
          showConfirmButton: false,
          timer: 2500,
          allowOutsideClick: false,
          allowEscapeKey: false,
        });
      } else {
        NProgress.start();
        let docRef = db.collection("nuevo_peligro").doc(this.id_peligro);
        docRef.get().then((doc) => {
          if (doc.exists) {
            this.agregar_efecto(
              doc.data().p_nuevo_peligro,
              id_peligro,
              id_subcla,
              efectos
            );
          }
        });
        NProgress.done();
        NProgress.remove();
      }
    },

    agregar_efecto(peligro, id_peligro, id_subcla, efectos) {
      NProgress.start();
      var n = new Date();
      // AÑO
      var y = n.getFullYear();
      // MES
      var m = n.getMonth() + 1;
      // DÍA
      var d = n.getDate();
      // SE ORDENA A GUSTO
      this.fecha = d + "/" + m + "/" + y;
      // HORAS
      var horas = n.getHours();
      // MINUTOS
      var minutos = n.getMinutes();
      // SEGUNDOS
      var segundos = n.getSeconds();
      // VARIABLE QUE LO ALMACENA
      this.hora_actual = horas + ":" + minutos + ":" + segundos;

      let agregar_efectos = db
        .collection("nuevo_efecto_posible")
        .get()
        .then((querySnapshot) => {
          let data = [];
          querySnapshot.forEach((doc) => data.push(doc.data()));
          data = data.map((efecto) => efecto.e_id_subcla);
          if (data.includes(id_subcla)) {
            let consultar_if_efecto = db
              .collection("nuevo_efecto_posible")
              .where("e_id_subcla", "==", id_subcla)
              .get()
              .then((querySnapshot) => {
                querySnapshot.forEach((doc) => {
                  this.c_key_efecto = `${doc.id}`;
                  this.c_efecto = doc.data().e_efecto_posible;
                });
                let resultado1 = this.c_efecto.concat(efectos);
                db.collection("nuevo_efecto_posible")
                  .doc(this.c_key_efecto)
                  .set({
                    e_efecto_posible: resultado1,
                    e_id_peligro: id_peligro,
                    e_id_subcla: id_subcla,
                    e_peligro: peligro,
                    e_fecha_registro: this.fecha,
                    e_hora_registro: this.hora_actual,
                    e_registrado_por: this.$store.state.email,
                  });
              });
            Swal.fire({
              position: "center",
              icon: "success",
              title: "Efecto agregado exitosamente.",
              showConfirmButton: false,
              timer: 1500,
              allowOutsideClick: false,
              allowEscapeKey: false,
            });
          } else {
            let newClienteRef = db.collection("nuevo_efecto_posible").doc();
            let id = newClienteRef.id;
            db.collection("nuevo_efecto_posible").doc(id).set({
              e_efecto_posible: efectos,
              e_id_peligro: id_peligro,
              e_id_subcla: id_subcla,
              e_peligro: peligro,
              e_fecha_registro: this.fecha,
              e_hora_registro: this.hora_actual,
              e_registrado_por: this.$store.state.email,
            });
            Swal.fire({
              position: "center",
              icon: "success",
              title: "Efecto agregado exitosamente.",
              showConfirmButton: false,
              timer: 1500,
              allowOutsideClick: false,
              allowEscapeKey: false,
            });
          }
        });
      NProgress.done();
      NProgress.remove();
      this.array_textos = [];
      this.id_peligro = "";
      this.id_subcla = "";
      $("#agregarefecto").modal("hide");
    },

    // CONSULTAR EFECTO POSIBLE
    consultar_efecto_posible(id, id_peligro, id_subcla) {
      NProgress.start();
      let docRef01 = db.collection("nuevo_peligro").doc(id_peligro);
      let docRef02 = db.collection("nuevo_subclasificacion").doc(id_subcla);
      let docRef03 = db.collection("nuevo_efecto_posible").doc(id);

      (async () => {
        await docRef01.get().then((doc) => {
          if (doc.exists) {
            this.c_key_peligro = doc.id;
            this.c_peligro = doc.data().p_nuevo_peligro;
          }
          this.consulta_subclasificaciones1(this.c_key_peligro);
        });

        await docRef02.get().then((doc) => {
          if (doc.exists) {
            this.c_subcla = doc.data().p_nuevo_subclasificacion;
          }
        });

        await docRef03.get().then((doc) => {
          if (doc.exists) {
            this.con_key = doc.id;
            this.con_efecto = doc.data().e_efecto_posible;
            this.con_peligro = this.c_peligro;
            this.con_subcla = this.c_subcla;
            this.con_fecha = doc.data().e_fecha_registro;
            this.con_hora = doc.data().e_hora_registro;
            this.con_registrado = doc.data().e_registrado_por;
          }
        });
      })();
    },

    editar_input(e) {
      console.log(e);
    },

    vaciar_variables() {
      $("#editarefectos").modal("hide");
      this.con_key = "";
      this.con_efecto = [];
      this.con_peligro = "";
      this.con_subcla = "";
      this.con_registrado = "";
    },

    consulta_subclasificaciones1(c_key_peligro) {
      NProgress.start();
      db.collection("nuevo_subclasificacion")
        .where("p_id_peligro", "==", c_key_peligro)
        .get()
        .then((querySnapshot) => {
          this.mostrar_subcla_descripcion = [];
          querySnapshot.forEach((doc) => {
            this.mostrar_subcla_descripcion.push({
              efecto_nuevo_sub: doc.data().p_nuevo_subclasificacion,
            });
          });
        });
      $("#editarefectos").modal("show");
      NProgress.done();
      NProgress.remove();
    },

    consulta_peligro() {
      db.collection("nuevo_peligro")
        .where("p_nuevo_peligro", "==", this.con_peligro)
        .get()
        .then((querySnapshot) => {
          this.array_peligro = [];
          querySnapshot.forEach((doc) => {
            this.array_peligro.push({
              c_key_peligro: `${doc.id}`,
              control_nuevo_peli: `${doc.data().p_nuevo_peligro}`,
            });
            this.consulta_subclasificaciones1(`${doc.id}`);
          });
        });
    },

    // FUNCIÓN PARA EDITAR EFECTO POSIBLE
    editar_id_peligro() {
      NProgress.start();
      db.collection("nuevo_peligro")
        .where("p_nuevo_peligro", "==", this.con_peligro)
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            this.editar_id_subcla(doc.id);
          });
        });
    },

    editar_id_subcla(id_peligro) {
      db.collection("nuevo_subclasificacion")
        .where("p_nuevo_subclasificacion", "==", this.con_subcla)
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            this.editar_efecto(id_peligro, doc.id);
          });
        });
    },

    editar_efecto(id_peligro, id_subcla) {
      NProgress.start();
      db.collection("nuevo_efecto_posible")
        .doc(this.con_key)
        .set({
          e_id_peligro: id_peligro,
          e_id_subcla: id_subcla,
          e_peligro: this.con_peligro,
          e_efecto_posible: this.con_efecto,
          e_fecha_registro: this.con_fecha,
          e_hora_registro: this.con_hora,
          e_registrado_por: this.$store.state.email,
        })
        .then(() => {});
      NProgress.done();
      NProgress.remove();
      id_peligro = "";
      id_subcla = "";
      this.con_efecto = "";
      $("#editarefectos").modal("hide");
    },

    eliminar_descripcion(id_efect_posible) {
      Swal.fire({
        title: "¿Seguro que desea eliminar este registro?",
        text: "¡Una vez eliminado, no podrás volver a ver el registro!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sí, Eliminar",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (result.value) {
          db.collection("nuevo_efecto_posible")
            .doc(id_efect_posible)
            .delete()
            .then(() => {
              Swal.fire({
                position: "center",
                icon: "success",
                title: "Efecto posible eliminado satisfactoriamente.",
                showConfirmButton: false,
                timer: 1500,
                allowOutsideClick: false,
                allowEscapeKey: false,
              });
            });
        }
      });
    },
  },
};
</script>